import amplitude from 'amplitude-js';
import config from 'react-global-configuration';
import mobx from 'mobx';

export default class AnalyticsResource {
    init() {
        const API_KEY = config.get('AMPLITUDE_API_KEY');
        amplitude.getInstance().init(API_KEY);
        this.enabled = false;
    }

    identify(id, data) {
        if (config.get('ANALYTICS_PARTITION') === data.partitionId) {
            if (amplitude.getInstance()) {
                amplitude.getInstance().setUserId(id);

                const identify = new amplitude.Identify()
                    .set('name', data.name)
                    .set('email', data.email)
                    .set('partitionId', data.partitionId);
                amplitude.getInstance().identify(identify);
                this.enabled = true;
            }
        }
    }

    page(page, data) {
        if (!this.enabled) return;
        if (amplitude.getInstance()) {
            amplitude.getInstance().logEvent(`${page.toUpperCase()}.PAGE_VIEW`, data);
        }
    }

    track(name, data) {
        if (!this.enabled) return;
        if (amplitude.getInstance()) {
            amplitude.getInstance().logEvent(name, data);
        }
    }

    generateMetadataFromStepAndFile(file, step, transition) {
        const data = {
            name: step.type.toUpperCase().replace('-', '_'),
            hasEmails: false,
        };
        Object.assign(
            data,
            _.pick(step, ['stepId', 'title']),
            _.pick(step.state, ['isComplete']),
            _.pick(file, ['tcFileId', 'typeOfSale'])
        );
        if (transition) {
            Object.assign(data, _.pick(mobx.toJS(transition), ['status', 'reasons']));
        }
        if (step.state.data.email || (step.state.data.emails && step.state.data.emails.length > 0)) {
            data.hasEmails = true;
        }
        return data;
    }

    generateMetadataFromFile(file) {
        const data = {};
        if (file) {
            Object.assign(data, _.pick(file, ['tcFileId', 'typeOfSale', 'originId', 'transactionId', 'origin']));
        }
        return data;
    }

    trackWorkflowStepStateChanged(file, step, transition) {
        try {
            if (!this.enabled) return;

            if (amplitude.getInstance()) {
                const name = 'WORKFLOW.STATE_CHANGED';
                amplitude.getInstance().logEvent(name, this.generateMetadataFromStepAndFile(file, step, transition));
            }
        } catch (err) {
            console.log(err);
        }
    }

    trackFileAction(file, action, properties) {
        try {
            if (!this.enabled) return;

            if (amplitude.getInstance()) {
                const name = 'FILE.ACTION',
                    data = this.generateMetadataFromFile(file);

                data.action = action ? action.toUpperCase() : 'NOT_SPECIFIED';

                if (data) {
                    Object.assign(data, properties);
                }
                amplitude.getInstance().logEvent(name, data);
            }
        } catch (err) {
            console.log(err);
        }
    }

    // trackWorkflowStepView (file, step) {
    //     try {
    //         if (!this.enabled) return
    //
    //         if (amplitude.getInstance()) {
    //             const name = step.type.toUpperCase().replace('-', '_') + '.STEP_VIEW'
    //             amplitude.getInstance().logEvent(name, this.generateMetadataFromStepAndFile(file, step))
    //         }
    //     }
    //     catch (err) {}
    // }
}



// WEBPACK FOOTER //
// ./src/resources/analytics-resource.js